import React from 'react';
import './QualityReport.css';

const QualityReport = ({ car, onViewReport  }) => {
  // Use real data from backend
  const qualityReport = car?.quality_report;
  const inspectionItems = car?.inspection_items_summary;

  if (!qualityReport) {
    return (
      <div className="quality-report-section">
        <h3 className="section-title">Quality report</h3>
        <p className="quality-subtitle">Quality report not available</p>
      </div>
    );
  }

  const getScoreColor = (score) => {
    if (score >= 9) return '#10b981';
    if (score >= 7.5) return '#f59e0b';
    return '#ef4444';
  };

  const getScoreLabel = (score) => {
    if (score >= 9) return 'Excellent';
    if (score >= 7.5) return 'Good';
    return 'Fair';
  };

  // Calculate total parts evaluated
  const totalParts = inspectionItems 
    ? Object.values(inspectionItems).reduce((sum, cat) => sum + cat.total, 0)
    : 0;

  return (
    <div className="quality-report-section">
      <h3 className="section-title">Quality report</h3>
      <p className="quality-subtitle">
        {totalParts} parts evaluated by automotive experts
      </p>

      <div className="quality-badges">
        {!qualityReport.meter_tampered && (
          <div className="quality-badge">
            <span className="badge-icon">✓</span>
            <span>Meter not tampered</span>
          </div>
        )}
        {!qualityReport.flooded && (
          <div className="quality-badge">
            <span className="badge-icon">✓</span>
            <span>Non-flooded</span>
          </div>
        )}
        <div className="quality-badge">
          <span className="badge-icon">✓</span>
          <span>Structure intact</span>
        </div>
      </div>

      <div className="quality-scores-grid">
        <div className="quality-score-item">
          <div className="score-header">
            <span className="score-icon">⚙️</span>
            <div className="score-info">
              <span className="score-title">Core systems</span>
              <span className="score-desc">Engine, transmission & chassis</span>
            </div>
          </div>
          <div 
            className="score-badge" 
            style={{ background: getScoreColor(qualityReport.core_systems_score) }}
          >
            {qualityReport.core_systems_score}
          </div>
          <span className="score-label">
            {getScoreLabel(qualityReport.core_systems_score)}
          </span>
        </div>

        <div className="quality-score-item">
          <div className="score-header">
            <span className="score-icon">🔌</span>
            <div className="score-info">
              <span className="score-title">Supporting systems</span>
              <span className="score-desc">Fuel supply, ignition & other systems</span>
            </div>
          </div>
          <div 
            className="score-badge" 
            style={{ background: getScoreColor(qualityReport.supporting_systems_score) }}
          >
            {qualityReport.supporting_systems_score}
          </div>
          <span className="score-label">
            {getScoreLabel(qualityReport.supporting_systems_score)}
          </span>
        </div>

        <div className="quality-score-item">
          <div className="score-header">
            <span className="score-icon">🪑</span>
            <div className="score-info">
              <span className="score-title">Interiors & AC</span>
              <span className="score-desc">Seats, AC, audio & other features</span>
            </div>
          </div>
          <div 
            className="score-badge" 
            style={{ background: getScoreColor(qualityReport.interiors_ac_score) }}
          >
            {qualityReport.interiors_ac_score}
          </div>
          <span className="score-label">
            {getScoreLabel(qualityReport.interiors_ac_score)}
          </span>
        </div>

        <div className="quality-score-item">
          <div className="score-header">
            <span className="score-icon">💡</span>
            <div className="score-info">
              <span className="score-title">Exteriors & lights</span>
              <span className="score-desc">Panels, glasses, lights & fixtures</span>
            </div>
          </div>
          <div 
            className="score-badge" 
            style={{ background: getScoreColor(qualityReport.exteriors_lights_score) }}
          >
            {qualityReport.exteriors_lights_score}
          </div>
          <span className="score-label">
            {getScoreLabel(qualityReport.exteriors_lights_score)}
          </span>
        </div>

        <div className="quality-score-item">
          <div className="score-header">
            <span className="score-icon">🔧</span>
            <div className="score-info">
              <span className="score-title">Wear & tear parts</span>
              <span className="score-desc">Tyres, clutch, brakes & more</span>
            </div>
          </div>
          <div 
            className="score-badge" 
            style={{ background: getScoreColor(qualityReport.wear_tear_score) }}
          >
            {qualityReport.wear_tear_score}
          </div>
          <span className="score-label">
            {getScoreLabel(qualityReport.wear_tear_score)}
          </span>
        </div>
      </div>

   <div className="quality-report-button-wrapper">
        <button
          className="view-quality-report-btn"
          onClick={onViewReport}
        >
          📋 View Quality Report
        </button>
      </div>
    </div>
  );
};

export default QualityReport;